import { CommonModule, DatePipe } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ComponentsModule } from 'src/app/components/components.module';
import { B3DesignSystemWebModule } from 'src/app/shared/b3-design-system-web/b3-design-system-web.module';

import { EmissionConsultComponent } from './emission-consult.component';
import { EmissionConsultDetailsDrawerComponent } from './emission-consult-details-drawer/emission-consult-details-drawer.component';
import { EmissionRejectAnalysisModalComponent } from './emission-consult-details-drawer/emission-reject-analysis-modal/emission-reject-analysis-modal.component';

@NgModule({
  declarations: [
    EmissionConsultComponent,
    EmissionConsultDetailsDrawerComponent,
    EmissionRejectAnalysisModalComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ComponentsModule,
    B3DesignSystemWebModule,
  ],
  exports: [
    EmissionConsultComponent,
  ],
  providers: [
    DatePipe,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class EmissionConsultModule { }
